import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdjustmentsHomeComponent } from './adjustments-home/adjustments-home.component';


const routes: Routes = [
  {
    path: '',
    component: AdjustmentsHomeComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AdjustmentsRoutingModule {
  static components = [];
}